export default "__VITE_ASSET__D9lgw9A5__"